
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// types
import type { Standard2025TariffsMappedTariff } from '@/core/types/billing.types'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        zoneId: {
            type: Number,
            default: 1
        },
        tariffs: {
            type: Array as PropType<Array<Standard2025TariffsMappedTariff>>,
            default: () => []
        },
        title: {
            type: String,
            default: null
        },
        isAuto: {
            type: Boolean,
            default: false,
        },
        isAvia: {
            type: Boolean,
            default: false,
        }
    },
})
